import { call, put, takeLatest } from "redux-saga/effects";
import { RESET_PASSWORD_REQUEST } from "../../actionTypes/resetPassword";
import {
  resetPasswordSuccess,
  resetPasswordFailure,
} from "../../action/resetPassword";
import { resetPassword } from "../../../com/resetPassword";
import { BaseResponse } from "../../response";
import { API_CODES } from "../../../constants";

interface ResetPasswordParams {
  emailOrPhone: string;
  newPassword: string;
  confirmPassword: string;
}

interface ResetPasswordAction {
  type: typeof RESET_PASSWORD_REQUEST;
  payload: ResetPasswordParams;
}

export function* resetPasswordWorker(
  action: ResetPasswordAction,
): Generator<unknown, void, BaseResponse> {
  try {
    const response = yield call(resetPassword, action.payload);
    const info = response.statusinfo.message;

    if (response.status === API_CODES.SUCCESS_CODE || response.status === "SUCCESS") {
      yield put(resetPasswordSuccess(info));
    } else {
      yield put(resetPasswordFailure(info));
    }
  } catch {
    yield put(resetPasswordFailure("Something went wrong"));
  }
}

export function* resetPasswordSaga(): Generator {
  yield takeLatest(RESET_PASSWORD_REQUEST, resetPasswordWorker);
}
